<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4 24C4 35.0457 12.9543 44 24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24ZM32.8455 17.08L21.6469 28.2786L16.1151 22.7468L14 24.8619L20.2374 31.1038C21.0183 31.8852 22.2847 31.8856 23.066 31.1046L34.9706 19.205L32.8455 17.08Z" fill-opacity="0.9"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
